(ns common.schema.entities.ai-task-config-override.schema
  (:require
   [common.schema.entities.integration.ai-options :as ai-options]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/single-ref-field :ai-task-config-override/pipeline
                         "Pipeline"
                         [:entity.type/pipeline]
                         {:authorization su/access-admin-admin})
    (su/keyword-field :ai-task-config-override/task-type
                      "Task type"
                      ai-options/task-type-options
                      {:authorization su/access-admin-admin})
    (su/url-field :ai-task-config-override/style-reference-url
                  "Style reference URL"
                  {:authorization su/access-admin-admin})
    (su/single-ref-field :ai-task-config-override/document-template
                         "Document template"
                         [:entity.type/attachment]
                         {:authorization su/access-admin-admin}))))
